export default __webpack_public_path__ + "static/1-fbc475ab1287bad028f8910d9ba7a0a8.jpeg";